module.exports = __webpack_public_path__ + "static/media/By-Laws-Trailwood.db84efc4.pdf";